// extracted by mini-css-extract-plugin
export default {"btn":"StandartButton_btn__gQCLJ","btnDisabled":"StandartButton_btnDisabled__z1PSf","userBtn":"StandartButton_userBtn__QWpXw"};